'use client';

import { useMemo } from 'react';
import { IconBrandValue } from '@/features/icons';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
import SectionHeading from './section-heading';
import { useLanguage } from '../context/language-context-provider';
const KhanoumiBrandValues = () => {
  const {
    t
  } = useLanguage();
  const ITEMS = useMemo(() => [{
    image: getCdnUrl('/_toad/images/about-us/polite.png'),
    title: t('values.respect.title'),
    description: t('values.respect.text'),
    desktopOrder: 1
  }, {
    image: getCdnUrl('/_toad/images/about-us/honesty.png'),
    title: t('values.honesty.title'),
    description: t('values.honesty.text'),
    desktopOrder: 3
  }, {
    image: getCdnUrl('/_toad/images/about-us/responsibility.png'),
    title: t('values.responsibility.title'),
    description: t('values.responsibility.text'),
    desktopOrder: 2
  }, {
    image: getCdnUrl('/_toad/images/about-us/expert.png'),
    title: t('values.expert.title'),
    description: t('values.expert.text'),
    desktopOrder: 4
  }], [t]);
  return <div className='homepage-container lg:mt-35' data-sentry-component="KhanoumiBrandValues" data-sentry-source-file="khanoumi-brand-values.tsx">
            <div className='relative flex flex-col items-center gap-7 lg:pt-33'>
                <SectionHeading title={t('values.title')} icon={<IconBrandValue />} className='lg:absolute lg:right-22 lg:top-0' data-sentry-element="SectionHeading" data-sentry-source-file="khanoumi-brand-values.tsx">
                    <span className='absolute bottom-full left-1/2 -z-10 hidden h-35 w-px bg-border-pink lg:inline-block' />
                </SectionHeading>

                <div className='grid grid-cols-2 gap-x-3 gap-y-5 lg:grid-cols-4 lg:gap-x-5'>
                    {ITEMS.map(({
          description,
          image,
          title,
          desktopOrder
        }) => <div key={title} className={cn('flex flex-col items-center gap-2 p-2 [&>svg]:h-20 [&>svg]:w-20', {
          'lg:order-1': desktopOrder === 1,
          'lg:order-2': desktopOrder === 2,
          'lg:order-3': desktopOrder === 3,
          'lg:order-4': desktopOrder === 4
        })}>
                            <img src={image} alt='title' className='h-20 w-20' />

                            <span className='text-center text-body-16 font-medium text-primary-main'>{title}</span>

                            <span className='text-center text-caption-12'>{description}</span>
                        </div>)}
                </div>
            </div>
        </div>;
};
export default KhanoumiBrandValues;